import get from 'transmute/get';
// @ts-expect-error untyped dependency
import { PreviewConfigContext } from './context/PreviewConfigContext';
import { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
// @ts-expect-error untyped dependency
import { PreviewConfigRecord } from './context/PreviewConfigContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function MessageBusPreviewContextProvider({
  setPreviewConfig,
  logPreviewSidebarObject,
  subjectId,
  objectType,
  children,
  closeSidebar,
  shouldOpenOnRender
}) {
  const sendPreviewObjectMessage = useSendCrmMessageTopic(TOPIC_NAMES.PREVIEW_OBJECT);
  const handleSetPreviewConfig = useCallback(config => {
    const objectTypeId = get('objectTypeId', config);
    const objectId = get('objectId', config);
    logPreviewSidebarObject(objectTypeId);
    setPreviewConfig(null);
    sendPreviewObjectMessage({
      objectTypeId: normalizeTypeId(objectTypeId),
      objectId
    });
  }, [sendPreviewObjectMessage, setPreviewConfig, logPreviewSidebarObject]);
  useEffect(() => {
    if (shouldOpenOnRender) {
      handleSetPreviewConfig(PreviewConfigRecord({
        objectTypeId: objectType,
        objectId: subjectId
      }));
    }
  }, [handleSetPreviewConfig, objectType, subjectId, shouldOpenOnRender]);
  const contextValue = useMemo(() => ({
    setPreviewConfig: handleSetPreviewConfig,
    closeSidebar,
    fromObjectId: subjectId,
    fromObjectType: objectType
  }), [handleSetPreviewConfig, objectType, subjectId, closeSidebar]);
  return /*#__PURE__*/_jsx(PreviewConfigContext.Provider, {
    value: contextValue,
    children: children
  });
}
MessageBusPreviewContextProvider.propTypes = {
  objectType: PropTypes.string.isRequired,
  closeSidebar: PropTypes.func.isRequired,
  logPreviewSidebarObject: PropTypes.func.isRequired,
  setPreviewConfig: PropTypes.func.isRequired,
  subjectId: PropTypes.string.isRequired,
  shouldOpenOnRender: PropTypes.bool.isRequired
};